import { OrbitControls, OrthographicCamera, PerspectiveCamera } from '@react-three/drei';
import { Vector3 } from '@react-three/fiber';

import { SceneMode } from '../core/SceneMode';

interface CameraProps {
  mode: SceneMode;
  setup?: CameraInitialSetup;
}

export interface CameraInitialSetup {
  position: Vector3;
  target: Vector3;
  zoom: number;
  minDistance: number;
  maxDistance: number;
}

const initialSetup: CameraInitialSetup = {
  position: [2, 2.5, 3],
  target: [0, 0, 0],
  zoom: 0.75,
  minDistance: 1,
  maxDistance: 10,
};

export default function Camera({ mode, setup }: CameraProps) {
  const is2d = mode === SceneMode.Scene2d;

  const { position, target, zoom, minDistance, maxDistance } = setup ?? initialSetup;

  return (
    <>
      <OrthographicCamera makeDefault={is2d} position={[0, 1, 0]} zoom={175} />
      <PerspectiveCamera makeDefault={!is2d} position={position} zoom={zoom} />
      <OrbitControls
        enableRotate={!is2d}
        makeDefault
        dampingFactor={0.06}
        target={target}
        minDistance={minDistance}
        maxDistance={maxDistance}
      />
    </>
  );
}
